module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ge-Hc-Ib-Ja.05532fb2.png";